/* ========================================================================
   ヘッダー PC メニュー hover 制御
   desktop 幅での hover 展開と theme editor の section 差し替えを管理する。
   ======================================================================== */
(() => {
  const HEADER_MENU_HOVER_BOUND_ATTR = 'auremeHeaderHoverBound';
  const HEADER_MENU_CLICK_GUARD_ATTR = 'auremeHeaderClickGuardBound';
  const HEADER_MENU_PAGEHIDE_CLEARER_STATE = 'AuremeHeaderMenuPagehideClearerState';
  /*
   * Theme Editor の section 差し替えで script が再評価されても、未発火の close timer を
   * グローバル側に集約し、pagehide 時にまとめて破棄できるようにする。
   */
  window[HEADER_MENU_PAGEHIDE_CLEARER_STATE] = window[HEADER_MENU_PAGEHIDE_CLEARER_STATE] || {
    closeTimerClearers: new Map(),
    isPagehideClearerBound: false,
  };
  const headerMenuPagehideClearerState = window[HEADER_MENU_PAGEHIDE_CLEARER_STATE];

  class DesktopHeaderMenuHoverController {
    static closeTimerClearers = headerMenuPagehideClearerState.closeTimerClearers;

    constructor(root = document) {
      this.root = root;
      this.mediaQuery = window.matchMedia('(min-width: 990px)');
    }

    connect() {
      this.bindParentLinkClickGuards();
      this.bindHeaderMenus();
    }

    bindParentLinkClickGuards() {
      for (const link of this.root.querySelectorAll('.header__menu-parent-link')) {
        if (link.dataset[HEADER_MENU_CLICK_GUARD_ATTR] === 'true') continue;

        link.dataset[HEADER_MENU_CLICK_GUARD_ATTR] = 'true';
        link.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      }
    }

    bindHeaderMenus() {
      for (const menu of this.root.querySelectorAll('header-menu')) {
        if (menu.dataset[HEADER_MENU_HOVER_BOUND_ATTR] === 'true') continue;

        const details = menu.querySelector('details');
        if (!details) continue;

        this.bindHeaderMenu(menu, details);
      }
    }

    bindHeaderMenu(menu, details) {
      const summary = details.querySelector('summary');
      let closeTimer;
      const clearCloseTimer = () => {
        if (!closeTimer) return;
        clearTimeout(closeTimer);
        closeTimer = null;
      };

      menu.dataset[HEADER_MENU_HOVER_BOUND_ATTR] = 'true';
      DesktopHeaderMenuHoverController.closeTimerClearers.set(menu, clearCloseTimer);
      DesktopHeaderMenuHoverController.bindPagehideClearer();

      menu.addEventListener('mouseenter', () => {
        if (!this.mediaQuery.matches) return;
        clearCloseTimer();
        this.closeOtherMenus(menu);

        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      });

      menu.addEventListener('mouseleave', () => {
        if (!this.mediaQuery.matches) return;
        clearCloseTimer();
        closeTimer = setTimeout(() => {
          if (typeof menu.close === 'function') menu.close();
          closeTimer = null;
        }, 200);
      });
    }

    static bindPagehideClearer() {
      if (headerMenuPagehideClearerState.isPagehideClearerBound) return;

      headerMenuPagehideClearerState.isPagehideClearerBound = true;
      window.addEventListener('pagehide', () => {
        DesktopHeaderMenuHoverController.clearCloseTimers();
      });
    }

    /*
     * section unload 時は対象 root 内だけ、pagehide 時は全体の timer を破棄し、
     * 差し替え後に古い timer が menu.close() を呼ばないようにする。
     */
    static clearCloseTimers(root = document) {
      const isScopedCleanup = root !== document;

      for (const [menu, clearCloseTimer] of DesktopHeaderMenuHoverController.closeTimerClearers) {
        if (isScopedCleanup && !root.contains(menu)) continue;

        clearCloseTimer();
        if (!menu.isConnected || isScopedCleanup) {
          DesktopHeaderMenuHoverController.closeTimerClearers.delete(menu);
        }
      }
    }

    closeOtherMenus(menu) {
      /* 他の開いているメニューを閉じる */
      for (const other of document.querySelectorAll('header-menu')) {
        if (other !== menu && typeof other.close === 'function') {
          other.close();
        }
      }
    }
  }

  function bindHeaderMenuInteractions(root = document) {
    new DesktopHeaderMenuHoverController(root).connect();
  }

  function bindDocumentEventOnce(flagName, eventName, listener) {
    if (window[flagName]) return;
    window[flagName] = true;
    document.addEventListener(eventName, listener);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        bindHeaderMenuInteractions(document);
      },
      { once: true },
    );
  } else {
    bindHeaderMenuInteractions(document);
  }

  bindDocumentEventOnce('AuremeHeaderMenuSectionLoadBound', 'shopify:section:load', (event) => {
    bindHeaderMenuInteractions(event.target);
  });

  bindDocumentEventOnce('AuremeHeaderMenuSectionUnloadBound', 'shopify:section:unload', (event) => {
    DesktopHeaderMenuHoverController.clearCloseTimers(event.target);
  });
})();
